import { MonthlyAverageModel } from '../models/monthly-average';

/**
 * Adapter para converter dados da API de média mensal
 */
export class MonthlyAverageAdapter {
  /**
   * Converte os dados da API para o modelo MonthlyAverageModel
   * @param data Dados retornados pela API
   * @returns Objeto MonthlyAverageModel
   */
  static fromApi(data: any): MonthlyAverageModel {
    return {
      id: data.id,
      stationId: data.stationId,
      averageTypeName: data.averageTypeName,
      year: data.year,
      month: data.month,
      averageTemperature: data.averageTemperature,
      totalRain: data.totalRain,
      creationDate: data.creationDate,
    };
  }
}
